import z from "zod";
export const IncidentWorkItemStatusValues = [
    "unknown",
    "in-progress",
    // Place of safety statuses
    "awaiting-arrival",
    "arrived-at-place-of-safety",
    "form-shared",
    // This is used when the incident has been shared with the NHS
    "nhs-form-accepted",
    // This is when police have been requested for support
    "police-presence-requested",
    "police-presence-not-requested",
    "ended",
];
export const IncidentWorkItemStatusSchema = z.enum(IncidentWorkItemStatusValues);
//# sourceMappingURL=incidentWorkItem.js.map